import { JSX, Match, Switch } from "solid-js";
import { isAndroid, isIOS } from "~/utils/platform";
import { openModalV2 } from "~/shared_states/modal";
import { PaymentLoaderProvider } from "./context/payment_loader_context";
import { QrCodeView } from "./fragments/qr_code_view";
import { IosUpiAppsView } from "./fragments/ios_upi_apps_view";
import { AndroidUpiView } from "./fragments/android_upi_view";

export interface PaymentLoaderTelescopeProps {
  orderId: string;
  amount: number;
  brandImageUrl: string;
  onClose: () => void;
  reInit: () => void;
  onPaymentComplete: () => void;
  onPaymentFailed: (failureReason: string) => void;
}

/**
 * Opens the Payment Loader Modal in telescope design
 * Used for UPI payment flow in Hubble mode
 */
export function openPaymentLoaderTelescope(props: PaymentLoaderTelescopeProps) {
  openModalV2(() => <PaymentLoaderTelescope {...props} />, {
    preventClose: true,
  });
}

/**
 * Payment Loader Component - Telescope Design System
 * Displays different views based on platform:
 * - Desktop: QR code for scanning
 * - iOS: Clickable UPI app tiles
 * - Android: Select UPI app button
 */
export function PaymentLoaderTelescope(
  props: PaymentLoaderTelescopeProps
): JSX.Element {
  return (
    <PaymentLoaderProvider
      orderId={props.orderId}
      amount={props.amount}
      onClose={props.onClose}
      reInit={props.reInit}
      onPaymentComplete={props.onPaymentComplete}
      onPaymentFailed={props.onPaymentFailed}
    >
      <Switch>
        {/* iOS - Show UPI app tiles grid */}
        <Match when={isIOS()}>
          <IosUpiAppsView />
        </Match>

        {/* Android - Show select UPI app button */}
        <Match when={isAndroid()}>
          <AndroidUpiView />
        </Match>

        {/* Desktop (default) - Show QR code */}
        <Match when={true}>
          <QrCodeView />
        </Match>
      </Switch>
    </PaymentLoaderProvider>
  );
}
